import Header from "../components/Header";
import Footer from "../components/Footer";
import PageHero from "../components/PageHero";
import CTABand from "../components/CTABand";
import { MapPin, Activity, Scale, GraduationCap } from "lucide-react";
import { IMPACT_STATS, IMPACT_HIGHLIGHTS } from "../data/pages";
import { PHOTOS } from "../data/photos";

const ICONS = { MapPin, Activity, Scale, GraduationCap };

const CommunityImpactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <PageHero
          eyebrow="Community Impact"
          title="The reach of peer-led recovery."
          description="Recovery happens in community. The numbers below are a window into the lives, families, and neighborhoods touched by Recovery Connections every year — made possible by our peer specialists, partners, donors and volunteers."
          breadcrumbs={[{ label: "About Us", href: "/about" }, { label: "Community Impact" }]}
          image={PHOTOS.meeting4}
        />

        <section className="py-20 md:py-24 bg-white">
          <div className="max-w-7xl mx-auto px-5 md:px-8">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-12">
              {IMPACT_STATS.map((s) => (
                <div key={s.label} className="border-l-2 border-[hsl(var(--rc-gold))] pl-5">
                  <div className="font-serif-display text-[44px] md:text-[56px] leading-none font-semibold text-[hsl(var(--rc-deep))]">
                    {s.value}
                  </div>
                  <div className="mt-2 text-[14px] text-[hsl(var(--rc-slate))]">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 md:py-24 rc-section-soft">
          <div className="max-w-7xl mx-auto px-5 md:px-8">
            <div className="max-w-2xl mb-12">
              <p className="text-[12px] tracking-[0.22em] uppercase text-[hsl(var(--rc-purple))] font-semibold">
                Where impact happens
              </p>
              <h2 className="font-serif-display mt-3 text-[34px] md:text-[42px] leading-[1.1] font-semibold text-[hsl(var(--rc-deep))]">
                Four pillars, one community.
              </h2>
            </div>
            <div className="grid md:grid-cols-2 gap-5">
              {IMPACT_HIGHLIGHTS.map((h) => {
                const Icon = ICONS[h.icon] || MapPin;
                return (
                  <div
                    key={h.title}
                    className="rc-card-hover bg-white border border-[hsl(var(--border))] rounded-2xl p-7 flex gap-5"
                  >
                    <div className="w-12 h-12 rounded-xl bg-[hsl(var(--rc-purple-soft))] flex items-center justify-center shrink-0 text-[hsl(var(--rc-purple))]">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <h3 className="font-serif-display text-[22px] font-semibold text-[hsl(var(--rc-deep))]">
                        {h.title}
                      </h3>
                      <p className="mt-2 text-[14.5px] leading-[1.65] text-[hsl(var(--rc-slate))]">
                        {h.body}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="py-20 md:py-24 bg-white">
          <div className="max-w-5xl mx-auto px-5 md:px-8 text-center">
            <p className="text-[12px] tracking-[0.22em] uppercase text-[hsl(var(--rc-purple))] font-semibold">
              In their words
            </p>
            <blockquote className="font-serif-display mt-5 text-[28px] md:text-[40px] leading-[1.25] font-medium text-[hsl(var(--rc-deep))] italic">
              “It has been a dream that these people here are helping people just like me. It feels like home.”
            </blockquote>
            <div className="mt-6 text-[13px] tracking-[0.18em] uppercase text-[hsl(var(--muted-foreground))]">
              — Recovery Connections Participant
            </div>
          </div>
        </section>

        <CTABand
          eyebrow="Support our work"
          title="Help us widen the reach of recovery."
          body="Your support — of time, money, or partnership — directly multiplies the lives we can touch."
          primary={{ label: "Donate Now", href: "/donate" }}
          secondary={{ label: "Other ways to help", href: "/ways-to-help" }}
        />
      </main>
      <Footer />
    </div>
  );
};

export default CommunityImpactPage;
